import { animate, state, style, transition, trigger } from '@angular/animations';
import { SelectionModel } from '@angular/cdk/collections';
import { AfterContentInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatOptionModule } from '@angular/material/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ELIMSSample } from 'src/app/domain/ELIMS/ELIMS-sample';
import { Configuration } from 'src/app/domain/configuration';
import { SampleFilters } from 'src/app/model/sample-filters.model';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { SampleService } from 'src/app/services/sample.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { DatePipe } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-sample-list',
    templateUrl: './sample-list.component.html',
    styleUrl: './sample-list.component.scss',
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        FormsModule,
        MatButtonModule,
        PreventDoubleClickDirective,
        MatSelectModule,
        MatOptionModule,
        MatIconModule,
        MatCheckboxModule,
        DatePipe,
    ],
})
export class SampleListComponent implements OnInit, AfterContentInit {
    @ViewChild(MatSort, { static: false }) sort!: MatSort;
    // displayedColumns: string[] = ['Project', 'EolReference', 'SampleCode', 'ClientSampleCode', 'Matrix', 'ReceptionDate', 'select'];
    displayedColumns: string[] = ['BatchCode'];
    SampleList: ELIMSSample[][] = [];
    dataSource = new MatTableDataSource();
    // SelectSampleList: ELIMSSample[] = [];
    Filters: SampleFilters = new SampleFilters();

    // DateDebut: Date = moment(new Date()).subtract(1, 'months').toDate();
    // DateFin: Date = new Date();
    // ReferenceEOL: string = '';
    // ReferenceClient: string = '';
    // CodeDossier: string = '';
    // Projet: string = '';
    // MainContactName: string = ''

    selection = new SelectionModel<ELIMSSample>(true, []);

    AvailableConfigurationList: Configuration[] = [];
    SelectedConfiguration?: Configuration;

    expandedElement: ELIMSSample | null = null;
    console = console;
    constructor(
        public Task: LoadingTask,
        private coreData: CoreData,
        private SampleService: SampleService,
        private configurationService: ConfigurationService,
        private _adapter: DateAdapter<any>,
        @Inject(MAT_DATE_LOCALE) private _locale: string) {
        this._locale = 'fr';
        this._adapter.setLocale(this._locale);
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {

        this.getConfigurationForMe();

        setTimeout(() => {
            if (this.coreData.LastSearch) {
                this.Filters.DateDebut = new Date(this.coreData.LastSearch.DateDebut);
                this.Filters.DateFin = new Date(this.coreData.LastSearch.DateFin);
                this.Filters.CodeDossier = this.coreData.LastSearch.CodeDossier;
                this.Filters.Projet = this.coreData.LastSearch.Projet;
                this.Filters.MainContactName = this.coreData.LastSearch.MainContactName;
                this.Filters.ReferenceClient = this.coreData.LastSearch.ReferenceClient;
                this.Filters.ReferenceEOL = this.coreData.LastSearch.ReferenceEOL;
                this.searchSampleByFilters()
            }
        })
    }

    hasLineBlocked() {
        return this.SampleList.flat().find(x => x.IsBlocked)
    }

    setBatchVisibility(s: ELIMSSample) {
        s.IsVisible = !s.IsVisible;
    }

    searchSampleByFilters() {
        this.clear();
        this.SampleService.getSampleByFilters(this.Filters).subscribe(x => {
            if (x && x.length > 0) {
                // this.SampleList = x;
                this.generateSubListByBatchCode(x);
                this.coreData.LastSearch = this.Filters;
                this.dataSource.data = this.SampleList;
                this.dataSource.sort = this.sort;
            }
        })
    }

    generateSubListByBatchCode(list: ELIMSSample[]) {
        let i = -1
        this.SampleList[0] = [];
        list.forEach(x => {

            if (i === -1 || x.BatchCode !== this.SampleList[i][0].BatchCode) {
                i++
                this.SampleList[i] = [];
            }
            this.SampleList[i].push(x)
        })
        
    }

    getConfigurationForMe() {
        this.configurationService.GetMyConfigurationList(true).subscribe(x => {
            this.AvailableConfigurationList = x;
        })
    }

    clear() {
        this.SelectedConfiguration = undefined;
        this.selection.clear();
        this.SampleList = [];
    }

    export() {
        if (!this.SelectedConfiguration)
            return;

        this.configurationService.export(this.SelectedConfiguration.Code, this.selection.selected.map(x => x.SampleCode)).subscribe(x => {
            this.promptFile(x);
        })
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.SampleList.length;
        return numSelected === numRows;
    }

    toggleAllRows() {
        if (this.isAllSelected()) {
            this.selection.clear();
            return;
        }

        this.selection.select(...this.SampleList.flat().filter(x => !x.IsBlocked));
    }

    selectFullBatch(batchCode: string) {
        this.selection.select(...this.SampleList.flat().filter(x => x.BatchCode === batchCode));
        
    }

    hasSampleBlockedInBatch(batchCode: string) {
        return this.SampleList.flat().find(x => x.BatchCode === batchCode && x.IsBlocked);
    }
    
    promptFile(x: any) {
        var url = window.URL.createObjectURL(x.body);
        var a = document.createElement('a');

        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(x.headers.get('Content-Disposition'));
        if (matches != null && matches[1]) {
            a.download = matches[1].replace(/['"]/g, '');
        }

        a.href = url;
        // a.download = x.fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();  //afterwards we remove the element again 
    }
}
